"use client";

import { Leaf, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function SolucionesDeRecuperaciN() {
  const rows = [{
    index: "01 / CONSULTA",
    badgeColor: "bg-[--blush-soft]/20 text-[--primary]",
    tapeColor: "bg-[--gold-accent]/30",
    tilt: "-rotate-2",
    title: "Diagnóstico clínico preciso.",
    body: "Analizamos tu salud capilar con tecnología de vanguardia para entender el origen de tu caso. Sin promesas vacías, solo ciencia y honestidad médica.",
    cta: "Solicitar consulta gratuita",
    imageLeft: true,
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/consulta_capilar.webp",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/consulta_capilar.webp-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/consulta_capilar.webp-wvc-sizes",
      alt: "Dra. Soto realizando diagnóstico capilar"
    },
    link: {
      href: "https://​https://msinstitutocapilar.com/contacto/",
      newTab: true
    }
  }, {
    index: "02 / PLANIFICACIÓN",
    badgeColor: "bg-[--blush-soft]/20 text-[--primary]",
    tapeColor: "bg-[--gold-accent]/30",
    tilt: "rotate-1",
    title: "Diseño personalizado natural.",
    body: "Cada línea de implantación se dibuja respetando tus rasgos faciales y tu fisionomía. Buscamos resultados que se integren con tu imagen de forma armónica.",
    cta: "Ver nuestra metodología",
    imageLeft: false,
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/diseno_capilar.webp",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/diseno_capilar.webp-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/diseno_capilar.webp-wvc-sizes",
      alt: "Planificación de diseño capilar personalizado"
    },
    link: {
      href: "https://msinstitutocapilar.com/cirugia-capilar/",
      newTab: true
    }
  }, {
    index: "03 / SEGUIMIENTO",
    badgeColor: "bg-[--blush-soft]/20 text-[--primary]",
    tapeColor: "bg-[--gold-accent]/30",
    tilt: "-rotate-2",
    title: "Acompañamiento constante.",
    body: "Tu evolución es nuestra prioridad. Realizamos un seguimiento exhaustivo post-intervención para asegurar que cada folículo reciba el cuidado necesario.",
    cta: "Conocer el proceso",
    imageLeft: true,
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/seguimiento_paciente.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/seguimiento_paciente.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/seguimiento_paciente.png-wvc-sizes",
      alt: "Seguimiento médico post-intervención capilar"
    },
    link: {
      href: "https://msinstitutocapilar.com/cirugia-capilar/",
      newTab: true
    }
  }];
  const headerReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="1715" id="soluciones-de-recuperación" className="bg-[--cream-base] text-[--navy-deep] relative overflow-hidden light ![padding:120px_0px_50px_0px]">
      <div className="max-w-[1360px] mx-auto px-8 lg:px-12">
        {}
        <div ref={headerReveal.ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 mb-20 md:mb-28 transition-all duration-700 ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <span className="font-default text-xs font-bold tracking-[0.18em] uppercase text-[--primary] !h-[41px] !w-[600px] md:text-sm">CONOCE NUESTRO MÉTODO</span>
              <span className="hidden md:block h-px w-20 bg-[--navy-deep]" />
            </div>
            <h2 className="font-default text-5xl leading-[0.95] tracking-tight text-[--navy-deep] !w-[1200px] md:text-6xl lg:text-7xl">Excelencia<br />en salud capilar</h2>
          </div>

          
        </div>

        {}
        <div className="space-y-20 md:space-y-28">
          {rows.map((row, i) => {
          const rowReveal = useRevealOnScroll<HTMLDivElement>({
            threshold: 0.15
          });
          return <div key={i} data-index={i} className="![margin:0px_0px_20px_0px]">
                <div ref={rowReveal.ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center transition-all duration-700 ${rowReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
              transitionDelay: `${i * 80}ms`
            }}>
                  {}
                  <div className={`lg:col-span-7 ${row.imageLeft ? "lg:order-1" : "lg:order-2"}`}>
                    <div className="relative group">
                      {}
                      <div className={`absolute z-20 ${row.imageLeft ? "top-[-18px] right-12" : "top-[-18px] left-12"} w-32 h-10 ${row.tapeColor} border border-[--navy-deep] rotate-[6deg] transition-transform duration-300 group-hover:rotate-[8deg]`} aria-hidden="true" />
                      <div className={`relative ${row.tilt} border border-[--navy-deep] rounded-lg overflow-hidden bg-[--card]`} style={{
                    boxShadow: "10px 10px 0 0 var(--blush-soft)"
                  }}>
                        <div className="overflow-hidden">
                          <img src={row.image.src} data-wvc-srcset={row.image.srcset} data-wvc-sizes={row.image.sizes} alt={row.image.alt} loading="lazy" decoding="async" className="block transition-transform duration-500 ease-out group-hover:scale-[1.03] ![margin:0px_60px_0px_60px] !h-[500px] !w-[380px]" />
                        </div>
                      </div>

                      {}
                      {i === 2 && <>
                          <Sparkles className="absolute top-10 left-10 w-12 h-12 text-[--primary] opacity-40 z-10" strokeWidth={1.5} aria-hidden="true" />
                          <Sparkles className="absolute bottom-16 right-20 w-8 h-8 text-[--navy-deep] opacity-20 z-10" strokeWidth={1.5} aria-hidden="true" />
                        </>}
                    </div>
                  </div>

                  {}
                  <div className={`lg:col-span-5 ${row.imageLeft ? "lg:order-2" : "lg:order-1"}`}>
                    <div className={`inline-block ${row.badgeColor} border border-[--primary] rounded-none px-3.5 py-1.5 font-default text-xs font-bold tracking-[0.15em] uppercase mb-6 -rotate-2`}>
                      {row.index}
                    </div>
                    <h3 className="font-default text-3xl md:text-4xl lg:text-[2.5rem] leading-[1.05] tracking-tight text-[--navy-deep] mb-5">
                      {row.title}
                    </h3>
                    <p className="font-default text-base md:text-lg text-[--navy-deep]/80 leading-[1.6] mb-7 max-w-md">
                      {row.body}
                    </p>
                    <Link className="text-[--navy-deep] font-default font-bold text-base px-0 underline underline-offset-[6px] decoration-2 decoration-[--primary] hover:decoration-[--navy-deep] hover:no-underline underline cursor-pointer" {...row.link}><Button variant="link" onClick={() => window.location.href = "/ContactPage"}>
                      {row.cta} &rarr;
                    </Button></Link>
                  </div>
                </div>

                {}
                {i < rows.length - 1 && <div className="flex justify-center mt-20 md:mt-28">
                    
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}